import { useEffect, useState } from 'react';
import { getWrapperClient, inWrapper } from './wrapperClient';

let nativeFullscreen = false;
export default function useTerminalFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(() => inWrapper() ? nativeFullscreen : !!document.fullscreenElement);
  useEffect(() => {
    const update = () => setIsFullscreen(!!(document.fullscreenElement || document.webkitFullscreenElement));
    document.addEventListener('fullscreenchange', update);
    document.addEventListener('webkitfullscreenchange', update);
    const unsubscribe = inWrapper() ? getWrapperClient().subscribe(message => {
      if (message.type === 'POS_FULLSCREEN_CHANGED') { nativeFullscreen = !!message.enabled; setIsFullscreen(nativeFullscreen); }
    }) : () => {};
    return () => { unsubscribe(); document.removeEventListener('fullscreenchange', update); document.removeEventListener('webkitfullscreenchange', update); };
  }, []);
  const toggleFullscreen = async () => {
    try {
      if (inWrapper()) {
        const enabled = !isFullscreen;
        await getWrapperClient().request('POS_TOGGLE_FULLSCREEN', { action: enabled ? 'enter' : 'exit' });
        nativeFullscreen = enabled; setIsFullscreen(enabled);
      } else if (document.fullscreenElement || document.webkitFullscreenElement) {
        await (document.exitFullscreen || document.webkitExitFullscreen)?.call(document);
      } else await (document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen)?.call(document.documentElement);
    } catch (error) { console.warn('Fullscreen unavailable:', error.message); }
  };
  return { isFullscreen, toggleFullscreen };
}
